import { cn } from '@heidi/utils';

import { focusRing } from '../styles/focus-ring';

export const resizablePanelGroupClasses = cn(
  'flex size-full data-[orientation=vertical]:flex-col'
);

// The v4 Panel hands `className` to its content wrapper — a row flex item of
// the `display:flex` panel in either group orientation, already stretched to
// the panel's height. A specified height keeps the same geometry but takes the
// wrapper out of the stretch relayout WebKit runs on auto-height flex items
// with percent-height descendants (webkit.org/b/87905), which compounds per
// nesting level. Callers' own height classes still win through `cn`.
export const resizablePanelContentClasses = cn('h-full');

// In v4, aria-orientation on the Separator describes the divider itself:
//   horizontal group → vertical divider (aria-orientation="vertical")
//   vertical group   → horizontal divider (aria-orientation="horizontal")
// The full-width/1px styles below apply when the divider is horizontal.
export const resizableHandleClasses = cn(
  'relative flex w-px items-center justify-center bg-border after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 aria-[orientation=horizontal]:h-px aria-[orientation=horizontal]:w-full aria-[orientation=horizontal]:after:start-0 aria-[orientation=horizontal]:after:h-1 aria-[orientation=horizontal]:after:w-full aria-[orientation=horizontal]:after:-translate-y-1/2 aria-[orientation=horizontal]:after:translate-x-0 [&[aria-orientation=horizontal]>div]:rotate-90',
  focusRing
);

export const resizableHandleGripClasses = cn(
  'z-10 flex h-4 w-3 items-center justify-center rounded-sm border bg-border'
);
